import { Injectable } from '@angular/core';

import moment from 'moment-timezone';

import { CookieService } from './cookie';
import { CookieKey } from './types';
import { getQueryParam } from './url-helpers';

@Injectable()
export class AuthHelpers {
  constructor(private cookieService: CookieService) {}

  public clearAccessTokenFromCookieBeforeExpiration(): void {
    const expiresAt = this.cookieService.get(CookieKey.AccessTokenExpiresAt);
    if (!expiresAt) return;

    if (moment().isAfter(moment.unix(<number>(<unknown>expiresAt)).subtract(6, 'days'))) {
      this.cookieService.delete(CookieKey.AccessToken);
      this.cookieService.delete(CookieKey.AccessTokenExpiresAt);
    }
  }

  public saveCompanyInCookie(value: string): void {
    this.cookieService.doSaveInCookie(CookieKey.Company, value);
  }

  public clearCompanyCookies(): void {
    this.cookieService.delete(CookieKey.Company, null, '.recruitee.com');
    this.cookieService.delete(CookieKey.Company, null, '.s.recruitee.com');
    this.cookieService.delete(CookieKey.Company, null, `.${document.domain}`);
    this.cookieService.delete(CookieKey.Company, null, `${document.domain}`);
  }

  public get isSuperadmin(): boolean {
    return getQueryParam('superadmin') === 'true';
  }

  public validateCompanyIdFromCookie(companyId: number, companies: Array<{ id: number }>): boolean {
    if (companyId) {
      return !!companies.find(c => c.id === companyId);
    }

    return false;
  }

  public deleteCookie(name: string): void {
    this.cookieService.delete(name);
  }

  public getSavedAccessToken(): string {
    if (this.isSuperadmin && this.cookieService.get(CookieKey.SuperadminAccessToken)) {
      return this.cookieService.get(CookieKey.SuperadminAccessToken);
    } else {
      return this.cookieService.get(CookieKey.AccessToken);
    }
  }
}
